/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 59a99c5e (Wed Sep  2 22:08:21 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { CashAmount, CashAmountFromJSON, CashAmountToJSON } from './'

/**
 *
 * @export
 * @interface FetchDirectorFinancialDetailsResponseFamilies
 */
export interface FetchDirectorFinancialDetailsResponseFamilies {
  /**
   * Unique identifier for the user of the family
   * @type number
   * @memberof FetchDirectorFinancialDetailsResponseFamilies
   */
  userKey?: number
  /**
   * Family's first name
   * @type string
   * @memberof FetchDirectorFinancialDetailsResponseFamilies
   */
  firstName: string
  /**
   * Family's last name
   * @type string
   * @memberof FetchDirectorFinancialDetailsResponseFamilies
   */
  lastName: string
  /**
   *
   * @type CashAmount
   * @memberof FetchDirectorFinancialDetailsResponseFamilies
   */
  familyOwesTutor: CashAmount
}

export function FetchDirectorFinancialDetailsResponseFamiliesFromJSON(
  json: any
): FetchDirectorFinancialDetailsResponseFamilies {
  return FetchDirectorFinancialDetailsResponseFamiliesFromJSONTyped(json, false)
}

export function FetchDirectorFinancialDetailsResponseFamiliesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchDirectorFinancialDetailsResponseFamilies {
  if (json === undefined || json === null) {
    return json
  }
  return {
    userKey: !exists(json, 'userKey') ? undefined : json['userKey'],
    firstName: json['firstName'],
    lastName: json['lastName'],
    familyOwesTutor: CashAmountFromJSON(json['familyOwesTutor']),
  }
}

export function FetchDirectorFinancialDetailsResponseFamiliesToJSON(
  value?: FetchDirectorFinancialDetailsResponseFamilies | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    userKey: value.userKey,
    firstName: value.firstName,
    lastName: value.lastName,
    familyOwesTutor: CashAmountToJSON(value.familyOwesTutor),
  }
}
